import React, { FC, useMemo } from 'react';

import { DataTypeInfo } from '@ariksa/data-scanning/api';
import { NativeResources } from '@ariksa/inventory-core/api';
import { customTheme } from 'theme';

import { Breakdown } from './Breakdown';
import { DistributionByDataLabels } from './DistributionByDataLabels';
import { getSensitiveDataBreakdown } from './utils';

const SENSITIVITY_COLORS: Record<string, string> = {
  Restricted: customTheme.colors.high,
  Confidential: customTheme.colors.medium,
  Internal: customTheme.colors.critical,
  Public: customTheme.colors.low,
};

interface SensitiveDataBreakdownProps {
  data: DataTypeInfo[];
  resourceType: NativeResources;
  isLoading: boolean;
}

export const SensitiveDataBreakdown: FC<SensitiveDataBreakdownProps> = ({
  data,
  resourceType,
  isLoading,
}) => {
  const sensitivityData = useMemo(
    () => getSensitiveDataBreakdown(data, resourceType).sensitivityData,
    [data, resourceType],
  );

  const sensitivityColorMap = useMemo(
    () =>
      sensitivityData.reduce<Record<string, string>>(
        (colors, item) => ({
          ...colors,
          [item.name]:
            SENSITIVITY_COLORS[item.name] ?? customTheme.colors.gray['300'],
        }),
        {},
      ),
    [sensitivityData],
  );

  return (
    <>
      <DistributionByDataLabels label="Breakdown by Sensitive Data Categories" />
      <Breakdown
        label="Breakdown by Data Sensitivity"
        data={sensitivityData}
        colorMap={sensitivityColorMap}
        isLoading={isLoading}
      />
    </>
  );
};
